const TaskConsts = {
    SuperAdmin_ReportTemplates: "F33751A5-4025-447C-B09D-F90928A9B8E1",
    ViewStage1: "00000000-0000-0000-0000-000000000004",
    ViewOnlyStage1: "0D710F34-4B47-417C-B33A-EADBE8CD7520",
    ViewStage2: "00000000-0000-0000-0000-000000000005",
    ViewOnlyStage2: "E8D44B04-30FB-460E-B698-678A2501AC6C",
    ViewStage3: "00000000-0000-0000-0000-000000000001",
    ViewOnlyStage3: "7D163343-7B6E-4B82-9036-024369E2A57A",
    HrmpsbTableViewAll: "35AB904C-E536-4DF1-B46E-34DDF3AD0E63",
    ScreeningAndSelectionViewAll: "33EE4766-1547-45AE-99BE-8AEE22061F5D",
    SummaryOfScores: "E23C1CBE-0890-4327-9A58-63C32B3CCEC2"
};

export default TaskConsts;
